import { z } from 'zod';
/**
 * Contratos de autenticação da EQUIPE (painel). Usados pela API (validação) e pelo painel (formulários/tipos).
 * Política de senha (decisão 18/09/2026): mínimo 10 caracteres, sem regras de composição,
 * bloqueio de senhas vazadas (verificação HIBP feita no servidor).
 */
export const SENHA_MIN = 10;
export const SENHA_MAX = 128;
export const senhaSchema = z
    .string()
    .min(SENHA_MIN, `A senha precisa ter pelo menos ${SENHA_MIN} caracteres`)
    .max(SENHA_MAX, `A senha pode ter no máximo ${SENHA_MAX} caracteres`);
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .max(254)
    .pipe(z.email('E-mail inválido'));
export const loginEquipeSchema = z.object({
    email: emailSchema,
    senha: z.string().min(1, 'Informe a senha').max(SENHA_MAX),
});
/** Código TOTP de 6 dígitos (aceita espaços digitados pelo usuário). */
export const codigoTotpSchema = z
    .string()
    .transform((c) => c.replace(/\s/g, ''))
    .pipe(z.string().regex(/^\d{6}$/, 'O código tem 6 dígitos'));
export const validarTotpSchema = z.object({
    tokenTemporario: z.string().min(1),
    codigo: codigoTotpSchema,
});
export const ativarTotpSchema = z.object({ codigo: codigoTotpSchema });
export const alterarSenhaSchema = z
    .object({
    senhaAtual: z.string().min(1, 'Informe a senha atual'),
    novaSenha: senhaSchema,
})
    .refine((d) => d.senhaAtual !== d.novaSenha, {
    message: 'A nova senha precisa ser diferente da atual',
    path: ['novaSenha'],
});
/** Foto de perfil: o navegador envia direto ao storage e depois confirma aqui. */
export const TIPOS_AVATAR_ACEITOS = ['image/jpeg', 'image/png', 'image/webp'];
export const TAMANHO_MAXIMO_AVATAR = 2 * 1024 * 1024;
export const prepararAvatarSchema = z.object({
    mimeType: z.string().trim().min(3).max(120),
    tamanho: z.coerce.number().int().positive().max(TAMANHO_MAXIMO_AVATAR),
});
export const confirmarAvatarSchema = z.object({ chave: z.string().min(1).max(300) });
//# sourceMappingURL=equipe.js.map